// i18n dictionary for DE / EN / FR / ES
export const dict = {
  de: {
    appTitle: "easybooking · WordPress Cockpit",
    wpSite: "mein-chalet.at",
    syncNow: "Jetzt synchronisieren",
    languageLabel: "Sprache",
    nav: {
      dashboard: "Dashboard",
      properties: "Objekte",
      calendar: "Kalender",
      channels: "Kanäle",
      rates: "Preise & Verfügbarkeit",
      inbox: "Anfragen",
      guests: "Gäste",
      chat_agent: "Chat-Agent",
      voice_agent: "Voice-Agent",
      booking_agent: "Buchungs-Assistent",
      admin_agent: "Admin (Sprache)",
      project_agent: "Projekt-Manager",
      cost: "KI-Kosten",
      competitor: "Wettbewerb & Yield",
      marketing: "Marketing-Hub",
      studio: "Social Media Studio",
      newsletter: "Newsletter",
      siteguard: "Site Guard",
      gerd40: "Event",
      com: "Website .com",
      strandhussiedlung: "Strandhussiedlung",
      restaurant: "Restaurant",
      import: "Import-Center",
      mail: "Mail-Hub",
      analytics: "Analytics",
      payments: "Zahlungen",
      owner_portal: "Owner-Portal",
      pricing: "Preise",
      support: "Support",
      shortcodes: "Shortcodes / Divi",
      settings: "Einstellungen",
    },
    kpi: {
      activeProperties: "Aktive Objekte",
      occupancy: "Auslastung",
      upcoming: "Anreisen (7 Tage)",
      revenue: "Umsatz (30 Tage)",
      inquiries: "Offene Anfragen",
      channelHealth: "Kanal-Status",
    },
    channelsTitle: "Channel Manager",
    channelsSubtitle: "Verteilung auf alle angeschlossenen Portale in einem Tool",
    inboxTitle: "Gäste-Anfragen",
    inboxSubtitle: "Automatische Antwort · Übergabe an Rezeption bei Bedarf",
    autoReplyDraft: "Automatische Antwort",
    sendAutoReply: "Antwort senden",
    escalate: "An Rezeption übergeben",
    status: {
      new: "Neu",
      auto_replied: "Automatisch beantwortet",
      escalated: "An Rezeption",
      resolved: "Erledigt",
    },
    properties: "Objekte",
    addProperty: "Objekt anlegen",
    bulkRateEdit: "Preis-Bulk-Editor",
    pushToChannels: "An Kanäle senden",
    settings: {
      title: "easybooking Verbindung",
      shellManager: "Shell Manager ID",
      apiKey: "easybooking API Key",
      propertyId: "easybooking Property ID",
      bookingHotel: "Booking.com Hotel ID",
      airbnbListing: "Airbnb Listing ID",
      autoReply: "Automatische Antworten aktiv",
      escalationMinutes: "Eskalation nach (Minuten)",
      receptionEmail: "Rezeptions-E-Mail",
      save: "Speichern",
    },
    shortcodeTitle: "Shortcodes & Divi Cloud Module",
    shortcodeHint: "Diese Shortcodes können in jeder WordPress-Seite oder im Divi Builder verwendet werden.",
    copy: "Kopieren",
    copied: "Kopiert ✓",
    perNight: "pro Nacht",
    bedrooms: "SZ",
    sleeps: "Pers.",
    lastSync: "Letzte Sync",
    nextSync: "Nächste",
    latency: "Latenz",
    connected: "Verbunden",
    disconnected: "Getrennt",
    errors: "Fehler",
    syncAll: "Alle Kanäle synchronisieren",
  },
  en: {
    appTitle: "easybooking · WordPress Cockpit",
    wpSite: "my-chalet.at",
    syncNow: "Sync now",
    languageLabel: "Language",
    nav: {
      dashboard: "Dashboard",
      properties: "Properties",
      calendar: "Calendar",
      channels: "Channels",
      rates: "Rates & Availability",
      inbox: "Inquiries",
      guests: "Guests",
      chat_agent: "Chat agent",
      voice_agent: "Voice agent",
      booking_agent: "Booking assistant",
      admin_agent: "Admin (voice)",
      project_agent: "Project manager",
      cost: "AI costs",
      competitor: "Competitors & Yield",
      marketing: "Marketing Hub",
      studio: "Social Media Studio",
      newsletter: "Newsletter",
      siteguard: "Site Guard",
      gerd40: "Event",
      com: "Website .com",
      strandhussiedlung: "Strandhussiedlung",
      restaurant: "Restaurant",
      import: "Import Center",
      mail: "Mail hub",
      analytics: "Analytics",
      payments: "Payments",
      owner_portal: "Owner portal",
      pricing: "Pricing",
      support: "Support",
      shortcodes: "Shortcodes / Divi",
      settings: "Settings",
    },
    kpi: {
      activeProperties: "Active Properties",
      occupancy: "Occupancy",
      upcoming: "Arrivals (7 days)",
      revenue: "Revenue (30 days)",
      inquiries: "Open Inquiries",
      channelHealth: "Channel Health",
    },
    channelsTitle: "Channel Manager",
    channelsSubtitle: "Distribute to every connected OTA from one cockpit",
    inboxTitle: "Guest Inquiries",
    inboxSubtitle: "Automated reply · handover to reception when needed",
    autoReplyDraft: "Auto-reply draft",
    sendAutoReply: "Send reply",
    escalate: "Hand over to reception",
    status: {
      new: "New",
      auto_replied: "Auto-replied",
      escalated: "At reception",
      resolved: "Resolved",
    },
    properties: "Properties",
    addProperty: "Add property",
    bulkRateEdit: "Bulk rate editor",
    pushToChannels: "Push to channels",
    settings: {
      title: "easybooking connection",
      shellManager: "Shell Manager ID",
      apiKey: "easybooking API Key",
      propertyId: "easybooking Property ID",
      bookingHotel: "Booking.com Hotel ID",
      airbnbListing: "Airbnb Listing ID",
      autoReply: "Auto-reply enabled",
      escalationMinutes: "Escalate after (minutes)",
      receptionEmail: "Reception email",
      save: "Save",
    },
    shortcodeTitle: "Shortcodes & Divi Cloud modules",
    shortcodeHint: "Paste these shortcodes into any WordPress page or Divi builder.",
    copy: "Copy",
    copied: "Copied ✓",
    perNight: "per night",
    bedrooms: "BR",
    sleeps: "guests",
    lastSync: "Last sync",
    nextSync: "Next",
    latency: "Latency",
    connected: "Connected",
    disconnected: "Disconnected",
    errors: "Errors",
    syncAll: "Sync all channels",
  },
  fr: {
    appTitle: "easybooking · Cockpit WordPress",
    wpSite: "mon-chalet.at",
    syncNow: "Synchroniser",
    languageLabel: "Langue",
    nav: {
      dashboard: "Tableau de bord",
      properties: "Logements",
      calendar: "Calendrier",
      channels: "Canaux",
      rates: "Tarifs & disponibilité",
      inbox: "Demandes",
      guests: "Invités",
      chat_agent: "Agent chat",
      voice_agent: "Agent vocal",
      booking_agent: "Assistant de réservation",
      admin_agent: "Admin (voix)",
      project_agent: "Chef de projet",
      cost: "Coûts IA",
      competitor: "Concurrence & Yield",
      marketing: "Hub Marketing",
      studio: "Studio Réseaux sociaux",
      newsletter: "Newsletter",
      siteguard: "Site Guard",
      gerd40: "Event",
      com: "Website .com",
      strandhussiedlung: "Strandhussiedlung",
      restaurant: "Restaurant",
      import: "Centre d'import",
      mail: "Hub e-mail",
      analytics: "Analytique",
      payments: "Paiements",
      owner_portal: "Portail propriétaire",
      pricing: "Tarifs",
      support: "Support",
      shortcodes: "Shortcodes / Divi",
      settings: "Paramètres",
    },
    kpi: {
      activeProperties: "Logements actifs",
      occupancy: "Occupation",
      upcoming: "Arrivées (7j)",
      revenue: "Revenu (30j)",
      inquiries: "Demandes ouvertes",
      channelHealth: "État canaux",
    },
    channelsTitle: "Channel Manager",
    channelsSubtitle: "Distribuez vers tous les portails depuis un seul cockpit",
    inboxTitle: "Demandes des clients",
    inboxSubtitle: "Réponse automatique · transfert à la réception",
    autoReplyDraft: "Brouillon de réponse",
    sendAutoReply: "Envoyer la réponse",
    escalate: "Transférer à la réception",
    status: {
      new: "Nouveau",
      auto_replied: "Répondu auto.",
      escalated: "Réception",
      resolved: "Résolu",
    },
    properties: "Logements",
    addProperty: "Ajouter un logement",
    bulkRateEdit: "Édition tarifs en lot",
    pushToChannels: "Envoyer aux canaux",
    settings: {
      title: "Connexion easybooking",
      shellManager: "ID Shell Manager",
      apiKey: "Clé API easybooking",
      propertyId: "ID propriété easybooking",
      bookingHotel: "ID hôtel Booking.com",
      airbnbListing: "ID annonce Airbnb",
      autoReply: "Réponse auto. activée",
      escalationMinutes: "Escalade après (min)",
      receptionEmail: "E-mail réception",
      save: "Enregistrer",
    },
    shortcodeTitle: "Shortcodes & modules Divi Cloud",
    shortcodeHint: "Collez ces shortcodes dans toute page WordPress ou dans Divi.",
    copy: "Copier",
    copied: "Copié ✓",
    perNight: "par nuit",
    bedrooms: "ch.",
    sleeps: "pers.",
    lastSync: "Dernière sync",
    nextSync: "Prochaine",
    latency: "Latence",
    connected: "Connecté",
    disconnected: "Déconnecté",
    errors: "Erreurs",
    syncAll: "Tout synchroniser",
  },
  es: {
    appTitle: "easybooking · Cockpit WordPress",
    wpSite: "mi-chalet.at",
    syncNow: "Sincronizar",
    languageLabel: "Idioma",
    nav: {
      dashboard: "Panel",
      properties: "Alojamientos",
      calendar: "Calendario",
      channels: "Canales",
      rates: "Tarifas y disp.",
      inbox: "Consultas",
      guests: "Huéspedes",
      chat_agent: "Agente chat",
      voice_agent: "Agente voz",
      booking_agent: "Asistente de reserva",
      admin_agent: "Admin (voz)",
      project_agent: "Gestor de proyecto",
      cost: "Costes IA",
      competitor: "Competencia & Yield",
      marketing: "Hub de Marketing",
      studio: "Estudio Redes Sociales",
      newsletter: "Newsletter",
      siteguard: "Site Guard",
      gerd40: "Event",
      com: "Website .com",
      strandhussiedlung: "Strandhussiedlung",
      restaurant: "Restaurant",
      import: "Centro de importación",
      mail: "Hub de correo",
      analytics: "Analítica",
      payments: "Pagos",
      owner_portal: "Portal propietario",
      pricing: "Precios",
      support: "Soporte",
      shortcodes: "Shortcodes / Divi",
      settings: "Ajustes",
    },
    kpi: {
      activeProperties: "Alojamientos activos",
      occupancy: "Ocupación",
      upcoming: "Llegadas (7 días)",
      revenue: "Ingresos (30 días)",
      inquiries: "Consultas abiertas",
      channelHealth: "Estado canales",
    },
    channelsTitle: "Channel Manager",
    channelsSubtitle: "Distribuye a todos los portales desde un solo cockpit",
    inboxTitle: "Consultas de huéspedes",
    inboxSubtitle: "Respuesta automática · traspaso a recepción",
    autoReplyDraft: "Borrador de respuesta",
    sendAutoReply: "Enviar respuesta",
    escalate: "Pasar a recepción",
    status: {
      new: "Nuevo",
      auto_replied: "Auto-respondido",
      escalated: "Recepción",
      resolved: "Resuelto",
    },
    properties: "Alojamientos",
    addProperty: "Añadir alojamiento",
    bulkRateEdit: "Editor masivo de tarifas",
    pushToChannels: "Enviar a canales",
    settings: {
      title: "Conexión easybooking",
      shellManager: "ID Shell Manager",
      apiKey: "Clave API easybooking",
      propertyId: "ID propiedad easybooking",
      bookingHotel: "ID hotel Booking.com",
      airbnbListing: "ID anuncio Airbnb",
      autoReply: "Auto-respuesta activa",
      escalationMinutes: "Escalada tras (min)",
      receptionEmail: "Email recepción",
      save: "Guardar",
    },
    shortcodeTitle: "Shortcodes y módulos Divi Cloud",
    shortcodeHint: "Pega estos shortcodes en cualquier página WordPress o en Divi.",
    copy: "Copiar",
    copied: "Copiado ✓",
    perNight: "por noche",
    bedrooms: "dorm.",
    sleeps: "pers.",
    lastSync: "Última sync",
    nextSync: "Próxima",
    latency: "Latencia",
    connected: "Conectado",
    disconnected: "Desconectado",
    errors: "Errores",
    syncAll: "Sincronizar todo",
  },
};

export const languages = [
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "es", label: "Español", flag: "🇪🇸" },
];

export const CHANNELS = {
  easybooking: { label: "easybooking.at", bg: "#D4AF37", fg: "#0B0F17" },
  booking_com: { label: "Booking.com", bg: "#003580", fg: "#FFFFFF" },
  airbnb: { label: "Airbnb", bg: "#FF5A5F", fg: "#FFFFFF" },
  expedia: { label: "Expedia", bg: "#FFC72C", fg: "#000000" },
  vrbo: { label: "Vrbo", bg: "#113B5F", fg: "#FFFFFF" },
  hometogo: { label: "HomeToGo", bg: "#00A896", fg: "#FFFFFF" },
  direct: { label: "Direkt", bg: "#10B981", fg: "#FFFFFF" },
};
